import $axios from "./index";

export const getColumn = id => {
    return $axios.get(`/api/category/${id}`);
}

export const getColumns = param => {
    return $axios.get('/api/category/list', param);
}

export const getArticles = param => {
    return $axios.get('/api/article/list', param);
}

export const searchArticles = param => {
    return $axios.get('/api/article/search', param);
}

export const getArticle = id => {
    return $axios.get(`/api/article/${id}`);
}

export const getNotices = param => {
    return $axios.get('/api/notice/list', param);
}

export const getNotice = id => {
    return $axios.get(`/api/notice/${id}`);
}

export const getArticleAdjacent = (param) => {
    return $axios.get(`/api/article/adjacent`, param);
}

export const getQuestionnaireRecord = (param) => {
    return $axios.get(`/biz/questionnaire/record`, param);
}

export const getQuestionnaire = () => {
    return $axios.get(`/biz/questionnaire`);
}

export const postQuestionnaire = (param) => {
    return $axios.post(`/biz/questionnaire/submit`,param);
}

export const postMgrApiVisitItem = (param) => {
    return $axios.post(`/api/visit/item`,param);
}
export const postVisitUnique = (param) => {
    return $axios.post(`/api/visit/unique`,param);
}
export const getProvinceList = (param) => {
  return $axios.get(`/biz/indexCity`,param);
}




// WEBPACK FOOTER //
// ./src/api/CmsApi.js